import { connect } from "react-redux";
import ProjectPages from "../../components/project-pages/ProjectPages";

export default connect(
  (state, props) => ({}),
  (dispatch, props) => ({})
)(ProjectPages);
